import { useQuery } from '@tanstack/react-query';
import { appConfigSchema } from '@repo/shared';
import { apiRequest } from '../../lib/api';

/**
 * Runtime config from the Worker (Mapbox token, feature flags). The map can't
 * be constructed until this resolves, so it's fetched once and cached for the
 * session.
 */
export function useAppConfig() {
  return useQuery({
    queryKey: ['config'],
    queryFn: () => apiRequest('/config', appConfigSchema),
    staleTime: Infinity,
  });
}
